import { FC } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@store/rootReducer";
import { setCartSidebarOpen } from "@store/slices/cartSlice";

import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import ErrorBoundary from "@components/ErrorBoundary";
import CartContent from "./components/CartContent";
import CartHeader from "./components/CartHeader";

import { appLayoutDimensions } from "../../AppLayout.constants";

const CartSidebar: FC = () => {
  const dispatch = useDispatch();
  const isCartSidebarOpen = useSelector((state: RootState) => state.cart.isCartSidebarOpen);

  const handleClose = () => dispatch(setCartSidebarOpen(false));

  return (
    <MuiDrawer
      open={isCartSidebarOpen}
      onClose={handleClose}
      anchor="right"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      slotProps={{ paper: { sx: { bgcolor: "background.default" } } }}
    >
      <Box
        data-cy="cart-sidebar"
        sx={{
          width: { xs: "100vw", sm: appLayoutDimensions.cartSidebarWidth },
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CartHeader onClose={handleClose} />
        <ErrorBoundary>
          <CartContent />
        </ErrorBoundary>
      </Box>
    </MuiDrawer>
  );
};

export default CartSidebar;
